import VuePictureCropper, { cropper } from 'vue-picture-cropper'
import { defineNuxtPlugin } from '#imports';

export default defineNuxtPlugin ((nuxtApp) => {
  if (import.meta.client) {
    nuxtApp.vueApp.component('VuePictureCropper', VuePictureCropper);
    nuxtApp.vueApp.provide('cropper', cropper);
  }
});
